import {lazy} from 'react'

const insecureRoutes = [
  {
    key: 'access.notAvailable',
    path: '/not-available',
    component: lazy(() => import('../../Views/auth/NotAvailable')),
    authority: 'public',
  }
]

export default insecureRoutes